__turbopack_context__.v({
  "close": "modal-close-button-module-sass-module__TeKcAq__close",
  "corner": "modal-close-button-module-sass-module__TeKcAq__corner",
  "square": "modal-close-button-module-sass-module__TeKcAq__square",
  "wallet": "modal-close-button-module-sass-module__TeKcAq__wallet",
});
